import React from 'react';

const ActiveProjects: React.FC = () => {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Active Projects</h1>
      <div className="bg-white rounded-lg shadow-md p-6">
        <p className="text-gray-600">Active projects will be displayed here.</p>
      </div>
    </div>
  );
};

export default ActiveProjects; 